class FrameFinderUtils {
    /**
     * Given its navigation coordinates, return the question block
     * @param {string} coordinates 
     * @returns {HTMLElement}
     */
    static getQuestionFromCoordinates(coordinates) {
        const [flowId, blockIndex] = coordinates.split('-');
        // FIXME: remove query selector on document
        // FIXME: start from current question (this) -> pass it as parameter
        const flowSection = document.getElementById(`frame-finder-flow-${flowId}`);
        const block = flowSection.querySelector(`#frame-finder-question-${blockIndex}`);

        return block;
    }

    /**
     * Given the question element get its 'next' buttons, if there are no answer options selected then disable them
     * @param {HTMLElement} nextQuestion 
     */
    static checkNextButtonState(nextQuestion) {
        const nextButtons = nextQuestion.querySelectorAll('.next-button, .button-arrow');
        const selectedOptions = nextQuestion.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

        nextButtons.forEach(nextButton => {
            nextButton.disabled = selectedOptions.length === 0;
        });
    }


    /**
     * Retrieve the answer history object, loop through the values and for each one of them
     * create a string for the filter that must be set, like " filterName=filterValue "
     * 
     * Once it gets all the paired filter from the answer history, 
     * join them using the "&" character and return the resulting string. 
     * @returns {string} filters url - e.g.: "filter.p.m.custom.lens_category=Blue+Light&filter.p.m.custom.lens_category=Sunglasses"
     */
    static getFiltersUrl() {

        const answerHistory = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];
        let filters = [];

        answerHistory.forEach((ansObj) => {

            ansObj[FRAME_FINDER_ANSWER_KEYS.filterValue].forEach((filterValue, index) => { 

                if (filterValue != 'no-preference' && filterValue != '') {
                    filters.push(`${ansObj[FRAME_FINDER_ANSWER_KEYS.filterName][index]}=${filterValue}`);
                }
            });
        });

        const filtersUrl = filters.join('&');
        return filtersUrl;
    }

    /**
     * Given the question coordinates and wheter it's before or after the current one, set its index and update the progress bar
     * @param {string} coordinates The coordinates for the question that needs the index set
     * @param {boolean} isQuestionNext whether the question is after or before the current one
     */
    static setQuestionIndex(coordinates, isQuestionNext) {
        let nextQuestion = this.getQuestionFromCoordinates(coordinates);
        const answerHistory = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];
        const questionIndex = isQuestionNext ? answerHistory.length + 1 : answerHistory.length;

        if (questionIndex == 1) {
            nextQuestion.querySelector('.prev-button').disabled = true;
        }
        if (nextQuestion) {
            nextQuestion.querySelector('.frame-finder-question-indicator').textContent = `QUESTION ${questionIndex}`;
        }



        publish(PUB_SUB_EVENTS.ffProgresBarUpdate, { 'questionIndex': questionIndex, 'isQuestionNext': isQuestionNext });
    }

    /**
     * Retrieve the previous answers from the navigation history
     * @returns {string[]} previous answers
     */
    static getPreviousAnswers() {
        const navigationSteps = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || {};
        let prevAnswers = [];

        navigationSteps.forEach(navStep => {
            prevAnswers.push(navStep[FRAME_FINDER_ANSWER_KEYS.filterValue]);
        });

        return prevAnswers;
    }

    /**
     * Get all the input elements from the specified question block and for each one of them check if there is
     * one or more previous answers needed. If the needed answer is included in the previous answers then display
     * the option, else hide it
     * @param {string} blockCoordinates 
     */
    static checkNeededPreviousAnswers(blockCoordinates) {

        const prevAnswers = this.getPreviousAnswers();

        const nextBlock = this.getQuestionFromCoordinates(blockCoordinates);
        const allOptions = nextBlock.querySelectorAll('input[type="radio"], input[type="checkbox"]');

        allOptions.forEach(option => {
            const neededPrevAnswers = option.dataset.previousAnswer;

            if (neededPrevAnswers) {
                const neededAnswersArray = neededPrevAnswers.split(',');
                const optionBlock = option.closest('.ff-answer-option');

                let answerFound = false;
                prevAnswers.forEach(ans => {
                    neededAnswersArray.forEach(neededAns => {
                        if (ans.includes(neededAns)) {
                            answerFound = true;
                        }
                    });
                });

                if (option.value == 'Children') {
                    prevAnswers.forEach(prevAns => {
                        if (prevAns.includes('Night+Driving+Lenses') || prevAns.includes('Driving+Lenses')) {
                            answerFound = false;
                        }
                    });
                }
                answerFound ? optionBlock.style.display = 'block' : optionBlock.style.display = 'none';
            }
        });
    }

    /**
     * Given a question block coordinates loop through its answer options, if an option
     * value exists in the lastAnswer array then check it
     * @param {string} coordinates 
     */
    static checkSelectedAnswers(coordinates) {
        const lastAnswer = this.getPreviousAnswers().at(-1);
        const questionBlock = this.getQuestionFromCoordinates(coordinates);

        const answerOptions = questionBlock.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        answerOptions.forEach(option => {
            option.checked = lastAnswer.includes(option.value);
        });
    }
}

class FrameFinderProgressBarUtils {

    /**
     * 
     * @param {HTMLElement} progressChunk the active progress chunk to expand
     * @param {string} questionIndex the index of the next question
     * @param {boolean} isQuestionNext whether the next question is previous or next to the current one
     */
    static updateProgressBar(progressChunk, questionIndex, isQuestionNext) {
        const animationOptions = {
            duration: 350,
            easing: 'ease'
        }

        const currentWidth = parseInt(isQuestionNext ? questionIndex - 1 : questionIndex + 1) * 100 / 7;
        const newWidth = questionIndex * 100 / 7;

        const widthKeyframeValue = isQuestionNext ? [`${currentWidth}%`, `${newWidth}%`] : [`${currentWidth}%`, `${newWidth}%`];

        progressChunk.animate({ width: widthKeyframeValue }, animationOptions);
        progressChunk.style.width = `${newWidth}%`;
    }
}